import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";
import React, { useState, useContext, useEffect } from "react";
import { Box } from "@mui/material";
import Navbar from "../../../../posnavbar/Navbar";
import { useNavigate } from "react-router-dom";
import {
  editUserDetails,
  resetPin,
  updatePin,
  getPosUserRole,
} from "../../../../../../config/Services";
import ProfileSettingsCard from "../ProfileSettingsCard/ProfileSettingsCard";
import "../ProfileSettingsCard/ProfileSettingsCard.css";
import { UserContext } from "../../../../../../App";
import Modal from "@mui/material/Modal";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import { useMutation } from "@tanstack/react-query";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import "./ProfileEditPage.css";

import { ArrowLeftIcon } from "@heroicons/react/20/solid";

export const ProfileEditPage = () => {
  const navigate = useNavigate();
  const {
    notificationPreferences,
    securitySettings,
    updateNotificationPreferences,
    updateSecuritySettings,
    city,
    setCity,
    color,
  } = useContext(UserContext);

  const showSnackbar = useSnackbar();
  const style = {
    backgroundColor: color === "dark" ? "#353a50" : "#fff",
    color: color === "dark" ? "white" : "black",
    width: 450,
    p: 4,
    borderRadius: 3,
  };

  const [inputBox, setInputbox] = useState(false);
  const [ren, setRen] = useState(true);

  const [retailUserDetails, setRetailUserDetails] = useState(() =>
    JSON.parse(localStorage.getItem("retailUserDetails"))
  );
  const firstName = retailUserDetails?.firstName ?? "-";
  const lastName = retailUserDetails?.secondName ?? "-";
  const email = retailUserDetails?.email ?? "-";
  const phone = retailUserDetails?.mobileNumber ?? "-";
  const [role, setRole] = useState("");
  // Identity Data State
  const user_roles = JSON.parse(localStorage.getItem("user_roles")) || [];
  const [identityData, setIdentityData] = useState({
    firstName: firstName,
    lastName: lastName,
    role: user_roles?.join(",") || "",
    outlet: retailUserDetails?.outlet || "",
    email: email,
    phone: phone,
    city: city || retailUserDetails?.city || "",
    employeeCode: retailUserDetails?.employeeCode || "",
    createdDate: retailUserDetails?.createdDate || "",
  });

  // Password Data State
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [fName, setFName] = useState(firstName);
  const [sName, setSName] = useState(lastName);
  const [emailId, setEmailId] = useState(email);
  const [cityValue, setCityValue] = useState(city);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [otp, setOtp] = useState("");
  const [pin, setPin] = useState("");
  const [cPin, setCPin] = useState("");
  const [timer, setTimer] = useState(30);

  const [isChangingPin, setIsChangingPin] = useState(false);
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleOTPChange = (e) => {
    const value = e.target.value?.trim();
    if (value?.length > 6) return;
    setOtp(value);
  };

  const handlePinChange = (e) => {
    const value = e.target.value?.trim();
    if (value?.length > 4) return;
    setPin(value);
  };

  const handleCPinChange = (e) => {
    const value = e.target.value?.trim();
    if (value?.length > 4) return;
    setCPin(value);
  };

  const handleResendOtp = () => {
    showSnackbar("OTP sent successfully", "success");
    setTimer(30);
    resetPinFn();
  };

  const sendOtp = useMutation({
    mutationFn: (payload) => resetPin(payload),
    onSuccess: () => {
      showSnackbar("OTP sent successfully", "success");
      handleOpen();
      setIsChangingPin(false);
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
      setIsChangingPin(false);
    },
  });

  const resetPinFn = () => {
    const payload = {
      mobile: retailUserDetails?.mobileNumber,
    };
    sendOtp.mutate(payload);
  };

  const saveResetPin = () => {
    const updatePayload = {
      mobile: retailUserDetails?.mobileNumber,
      primaryPassword: cPin,
      otp: otp,
    };

    if (Number(cPin) === Number(pin)) {
      updatePin(updatePayload)
        .then((response) => {
          showSnackbar("PIN changed successfully", "success");
          handleClose();
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
        });
    } else {
      showSnackbar("PIN doesn't match. Please enter the correct PIN", "error");
    }
  };
  const handleProfileChange = (section, field, value) => {
    if (section === "identity") {
      setIdentityData((prev) => ({ ...prev, [field]: value }));
      if (field === "firstName") setFName(value);
      if (field === "lastName") setSName(value);
      if (field === "email") setEmailId(value);
      if (field === "city") setCityValue(value);
    } else if (section === "notifications") {
      const updated = { ...notificationPreferences, [field]: value };
      updateNotificationPreferences(updated);
    } else if (section === "security") {
      // Handle toggles for security settings
      if (["twoFactor", "loginAlerts", "sensitiveActions"].includes(field)) {
        const updated = { ...securitySettings, [field]: value };
        updateSecuritySettings(updated);
      } else {
        // Handle password fields
        setPasswordData((prev) => ({ ...prev, [field]: value }));
      }
    }
  };

  const handleProfileAction = (action, data) => {
    if (action === "updatePin") {
      setIsChangingPin(true);
      resetPinFn();
    }
  };

  const handle = () => {
    const currentPath = window.location.pathname;

    if (currentPath === "/profile/edit") {
      navigate("/settings/accounts");
    } else {
      navigate("/");
    }
  };

  const handleCancel = () => {
    setInputbox(false);

    setIdentityData({
      firstName: retailUserDetails?.firstName || "-",
      lastName: retailUserDetails?.secondName || "-",
      role: retailUserDetails?.role || "",
      outlet: retailUserDetails?.outlet || "",
      email: retailUserDetails?.email || "-",
      phone: retailUserDetails?.mobileNumber || "-",
      city: retailUserDetails?.city || "",
      employeeCode: retailUserDetails?.employeeCode || "",
    });
    setFName(firstName);
    setSName(lastName);
    setEmailId(email);
    navigate("/settings/accounts");
  };

  const handleSave = () => {
    const payload = {
      uidx: retailUserDetails?.uidx,
      mobileNumber: identityData?.phone || phone,
      email: identityData?.email || emailId,
      firstName: identityData?.firstName || fName,
      secondName: identityData?.lastName || sName,
      city: identityData?.city || cityValue,
      profilePicture: "",
      tennatId: "",
      roles: retailUserDetails?.roles,
      contextPayload: {
        type: "",
        orgId: "",
        contextId: "",
      },
    };

    editUserDetails(payload, retailUserDetails?.uidx).then((res) => {
      const updatedUserData = res?.data?.data;
      const finalCity = updatedUserData?.city || identityData?.city || cityValue;
      const mergedUserData = { ...retailUserDetails, ...updatedUserData, city: finalCity };

      localStorage.setItem("retailUserDetails", JSON.stringify(mergedUserData));

      const updatedUserName = `${mergedUserData?.firstName || ""} ${
        mergedUserData?.secondName || ""
      }`.trim();
      localStorage.setItem("user_name", updatedUserName);

      setCity(finalCity);
      setRetailUserDetails(mergedUserData);
      setRen(!ren);
      navigate("/settings/accounts", { state: { updated: true } });
    });
    setInputbox(false);
  };

  return (
    <div className="profile-section">
      <Navbar>
        <Box className="profile-container" m={0} p={0}>
          <div className="profile-container-section">
            <section
              className="profile-header-section"
              style={{
                width: "100%",
                display: "flex",
                borderBottom: "1px solid rgba(203, 213, 225, 0.6)",
                paddingBottom: "1rem",
              }}
            >
              <div className="profile-header-section-left-div">
                <div className="button-profile-back">
                  {/* <PosCustomButton
                    iconOnRight={
                      <PosCustomIcon icon={<ArrowLeftIcon />} height="26px" width="26px" />
                    }
                    onClickFunction={handle}
                    height="35px"
                    width="35px"
                    radius="9999px"
                    variant="profile-back"
                  /> */}
                  <PosCustomIcon
                    icon={<ArrowLeftIcon />}
                    height="16px"
                    width="16px"
                    pointer={true}
                    onClickFunction={handle}
                  />
                </div>
                {/* <button className="button-profile-back" onClick={handle}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="m12 19-7-7 7-7"></path>
                    <path d="M19 12H5"></path>
                  </svg>
                </button> */}
                <div>
                  <p className="profile-header-section-profile">Edit profile</p>
                  {/* <p className="profile-header-section-sub-profile">
                    Update details, preferences, and security controls in one focused flow.
                  </p> */}
                </div>
              </div>

              <div className="profile-header-section-right-div">
                <PosCustomButton
                  radius="15px"
                  p="8px 8px"
                  width="120px"
                  height="38px"
                  title={"Cancel"}
                  onClickFunction={handleCancel}
                />
                <PosCustomButton
                  variant="primary-rounded"
                  radius="15px"
                  p="8px 8px"
                  width="120px"
                  height="38px"
                  title={"Save Changes"}
                  onClickFunction={handleSave}
                />
              </div>
            </section>

            <section className="profile-body-section">
              <div className="layout-grid edit-page-content">
                <div>
                  <ProfileSettingsCard
                    type="identity"
                    data={identityData}
                    onChange={handleProfileChange}
                  />

                  <ProfileSettingsCard
                    type="notifications"
                    data={notificationPreferences}
                    onChange={handleProfileChange}
                  />
                </div>
                <div>
                  <ProfileSettingsCard
                    type="security"
                    data={{
                      ...passwordData,
                      twoFactor: securitySettings?.twoFactor,
                      loginAlerts: securitySettings?.loginAlerts,
                      sensitiveActions: securitySettings?.sensitiveActions,
                    }}
                    onChange={handleProfileChange}
                    onAction={handleProfileAction}
                    isChangingPin={isChangingPin}
                  />

                  {/* <ProfileSettingsCard
                    type="summary"
                    data={{
                        notifications: notificationPreferences,
                        security: securitySettings,
                    }}
                    /> */}
                </div>
              </div>
            </section>
          </div>
          <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="pin-wrapper-modal-box"
          >
            <Box
              sx={{
                "&:focus": {
                  outline: "none",
                },
                ...style,
              }}
            >
              <div className="modal-header">
                <h2
                  style={{
                    fontSize: "1.25rem",
                    lineHeight: "1.75rem",
                    fontWeight: 700,
                    letterSpacing: "-0.025em",
                    color: "#0f172a",
                  }}
                >
                  Change Account PIN
                </h2>
                <p
                  style={{
                    marginTop: "0.5rem",
                    fontSize: "0.875rem",
                    lineHeight: "1.5rem",
                    color: "#64748b",
                  }}
                >
                  Enter The OTP First, then set and confirm your new PIN
                </p>
              </div>
              <Box className="change-pin-wrapper-box">
                <p className="old-pin-text">OTP </p>
                <input
                  value={otp}
                  onChange={handleOTPChange}
                  type="number"
                  className="change-pin-otp-input"
                />
                {/* <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  renderSeparator={<span>&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle="otp_input_box"
                  inputType="number"
                /> */}
              </Box>
              <Box className="change-pin-wrapper-box">
                <p className="old-pin-text">New PIN </p>
                <input
                  value={pin}
                  onChange={handlePinChange}
                  type="number"
                  className="change-pin-otp-input"
                />
                {/* <OtpInput
                  value={pin}
                  onChange={setPin}
                  numInputs={4}
                  renderSeparator={<span>&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle="otp_input_box"
                  inputType="number"
                /> */}
              </Box>
              <Box className="change-pin-wrapper-box">
                <p className="old-pin-text">Confirm New PIN </p>
                <input
                  value={cPin}
                  onChange={handleCPinChange}
                  type="number"
                  className="change-pin-otp-input"
                />
                {/* <OtpInput
                  value={cPin}
                  onChange={setCPin}
                  numInputs={4}
                  renderSeparator={<span>&nbsp;&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                  inputStyle="otp_input_box"
                  inputType="number"
                /> */}
              </Box>
              <Box className="resend-otp-wrapper-box">
                <p
                  onClick={timer === 0 ? handleResendOtp : null}
                  style={{
                    cursor: timer === 0 ? "pointer" : "not-allowed",
                    color: timer === 0 ? "blue" : "grey",
                  }}
                >
                  Resend OTP {timer > 0 && `(${timer}s)`}
                </p>
              </Box>
              <Box className="save-wrapper-box-forgot">
                <StyledButton color="red" variant="secondary" onClick={handleClose}>
                  Cancel
                </StyledButton>
                <StyledButton
                  onClick={saveResetPin}
                  disabled={cPin.length !== 4 || pin.length !== 4 || otp.length !== 6}
                >
                  Update Pin
                </StyledButton>
              </Box>
            </Box>
          </Modal>
        </Box>
      </Navbar>
    </div>
  );
};
